import { NetworkResponse } from "~/app/type/common";
import { requestREST } from "~/client/http/CommonHTTP";
import { IMyDealers } from "~/entity/Dealers";
import {
  IDealerListItem,
  IDealersListResponse,
  IGetDealersParams,
} from "~/entity/Dealers/model/schema";
import { paramsSerializer } from "~/shared/lib/paramsSerializer";

const dealersServiceMap = {
  showMyDealers: "/dealer/my",
  dealers: "/dealer/dealers",
};

// GET /dealer/dealers — список дилеров (для селектов). Опционально фильтруется
// по regmenId (когда выбран региональный менеджер).
// dealerSearch — object (Zod на сервере требует object, не string).
// Сериализуется через qs с arrayFormat: "brackets" → dealerSearch[dealerName]=...&dealerSearch[ids][]=...
export interface IDealerSearch {
  ids?: string[];
  code?: string;
  dealerName?: string;
  address?: string;
  city?: string;
  status?: string;
  inn?: string;
  category?: string;
}

export interface IDealerListParams {
  page?: number; // 0-indexed
  count?: number;
  dealerSearch?: IDealerSearch;
  regmenId?: number;
  status?: string;
}

export class DealersService {
  static GET = {
    getMyDealer: (
      limit: number,
      page: number,
      partName?: string,
      Region?: string,
      RegionEn?: string,
      FederalArea?: string,
      FederalAreaEn?: string,
    ): NetworkResponse<IMyDealers> =>
      requestREST.get(dealersServiceMap.showMyDealers, {
        params: {
          limit,
          page,
          partName,
          Region,
          RegionEn,
          FederalArea,
          FederalAreaEn,
          // PASDILER-2229: в списке "Выбрать дилера" показываем только активные ДЦ
          // Бэк ожидает массив: statuses[]=active
          statuses: ["active"],
        },
        paramsSerializer: (params) =>
          paramsSerializer(params, { allowEmptyArrays: true }),
      }),
    getDealerList: (
      params: IDealerListParams,
    ): NetworkResponse<IDealersListResponse<IDealerListItem>> =>
      requestREST.get(dealersServiceMap.dealers, {
        params,
        paramsSerializer: (params) =>
          paramsSerializer(params, { allowEmptyArrays: true }),
      }),
    getDealers: (
      params: IGetDealersParams,
    ): NetworkResponse<IDealersListResponse> =>
      requestREST.get(dealersServiceMap.dealers, { params }),
  };
}
